import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DefaultValues } from 'src/app/common/constant/constant';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { MediaManagerService } from 'src/app/services/media-manager/media-manager.service';
import { ConfirmationComponent } from 'src/app/components/common/confirmation/confirmation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import heic2any from 'heic2any'; // Import the library

declare var $: any;
declare var lightGallery: any;

interface PageEvent {
  initPage: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-upload-existing',
  templateUrl: './upload-existing.component.html',
  styleUrls: ['./upload-existing.component.scss']
})
export class UploadExistingComponent implements OnInit {
  @Input() pageAccess: string = '';
  @Input() apiData: any = [];
  @Input() mediaItems: any = [];
  @Input() existingItems: any = [];
  @Output() uploadAction: EventEmitter<any> = new EventEmitter();
  
  public bodyElem;
  public title:String = "File already exists";
  public initPage: number = 0;
  public rows: number = 1;
  public dynamicGid: any = 0;
  public totalRecords: any = 0;
  public lgTimeOut: number = 10;
  public lightGalleryPlugin: any;
  public assetPath: string = "assets/images";
  public mediaPath: string = `${this.assetPath}/media`;
  public audioThumb: string = `${this.mediaPath}/audio-medium.png`;
  public videoThumb: string = `${this.mediaPath}/video-medium.png`;
  public linkThumb: string = `${this.mediaPath}/link-medium.png`;
  public baseApiUrl: string = "";
  public fileAction: string = "view";
  public fileAccess: string = "existing-upload";
  public langPlaceholder: string = "Select Language";
  public defLang: any = [];
  public hideLabel: boolean = true;
  public galleryFlag: boolean = false;
  public initLoad: boolean = false;
  public loading: boolean = true;
  public initialLoad: boolean = true;
  public changeFlag: boolean = false;
  public submitFlag: boolean = false;
  public CBADomain: boolean = false;
  public userWorkstreams: any = [];
  public currentDate: any;
  public currentDateTime: any;
  public currentMediaItem: any = [];
  public actionItems: any = [];
  public checkActionItems: any = [];
  public fileActions: any = [{actionName: 'Use existing file', actionDesc: 'Upload with existing file.'}, {actionName: 'Overwrite the existing file.', actionDesc: 'Existing file will be removed and replaced with newly uploaded file'}, {actionName: 'Change file name', actionDesc: 'Change file name & Upload as a new file, it won’t affect the existing file.'}];

    public heicImageInterval: any;
      imageUrl: string | ArrayBuffer | null = null;

  public heicImageConverted: boolean = false;

  constructor(
    private router: Router,
    private apiUrl: ApiService,
    private commonApi: CommonService,
    private mediaApi: MediaManagerService,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    let currentDate = new Date();
    currentDate = moment.utc(currentDate).toDate(); 
    this.currentDate = moment(currentDate).local().format('X');
    this.currentDateTime = moment(currentDate).format('MMM DD, YYYY h:mm A');
    this.baseApiUrl = this.apiUrl.apiCollabticBaseUrl();
    let uws = localStorage.getItem('userWorkstreams');
    this.userWorkstreams = JSON.parse(uws);
    let defaultLanguage: any;
    if (localStorage.getItem('defaultLanguage')) {
      defaultLanguage = JSON.parse(localStorage.getItem('defaultLanguage'));
    } else {
      defaultLanguage = DefaultValues.language;
    }
    this.totalRecords = this.mediaItems.length;
    console.log(this.mediaItems)
    console.log(this.existingItems)
    this.bodyElem = document.getElementsByTagName('body')[0];
    let platformId:any = localStorage.getItem('platformId');
    platformId = (platformId == 'undefined' || platformId == undefined) ? platformId : parseInt(platformId);
    this.CBADomain = platformId == 3 ? true : false;
    this.existingItems.forEach(eitem => {
      let uploadedDate = moment.utc(eitem.createdOn).toDate(); 
      let localUploadedDate = moment(uploadedDate).local().format('MMM DD, YYYY h:mm A');
      eitem.date = localUploadedDate;
      eitem.mediaAction = '';
      eitem.setup = false;
      eitem.wsFlag = false;
      eitem.iframe = false;
      let flagId = eitem.flagId;
      let ext = eitem['fileExtension']?.toLowerCase();
      switch(flagId) {
        case 2:
          eitem.thumbFilePath = eitem.posterImage;
          break;
        case 3:
          eitem.thumbFilePath = this.audioThumb;
          break;
          case 4:
          case 5:
            let docThumb;
            let fileExt = 'png';
            switch (ext) {
              case 'pdf':
              case 'PDF':
                docThumb = 'pdf-medium';
                eitem.flagId = 4;
                eitem.iframe = true;
                let split = 'docs';
                let splitPath = eitem.filePath.split(split);
                if(!this.CBADomain) {
                  eitem.filePath = `${splitPath[0]}${split}/${ext}${splitPath[1]}`;
                }
                break;
              case 'xlsx':
              case 'xls':
                docThumb = 'xls-medium';
                break;
              case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
              case 'docx':
              case 'doc':
              case 'msword':
                docThumb = 'doc-medium';
                break;
              case 'pptx':
              case 'ppt':
                docThumb = 'ppt-medium';
                break;
              case 'txt':
                docThumb = 'txt-medium';
                eitem['excludeClass'] = "non-doc";
                break;
              case 'x-zip-compressed':
              case 'zip':
                docThumb = 'zip-medium';
                eitem['excludeClass'] = "non-doc";
                break;
              case 'exe':
                docThumb = 'exe-medium';
                eitem['excludeClass'] = "non-doc";
                break;
              case 'csv':
                docThumb = 'csv-medium';
                eitem['excludeClass'] = "non-doc";
                break;
              case 'html':
                docThumb = 'html-thumb-medium';
                eitem['excludeClass'] = "non-doc";
                break;  
              case 'dat':
                docThumb = 'dat-medium';
                eitem['excludeClass'] = "non-doc";
                break;
              default:
                docThumb = 'unknown-thumb';
                eitem['excludeClass'] = "non-doc";
                break;
            }
            if (eitem['fileType'] == 'application/pdf') {
              docThumb = 'pdf-medium';
            }
            if (eitem['fileType'] == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
              docThumb = 'ppt-medium';
            }
            if (eitem['fileType'] == 'link') {
              docThumb = 'link-medium';
            }
            let fileImg = `${this.mediaPath}/${docThumb}.${fileExt}`;
            eitem['thumbFilePath'] = fileImg;
            break;  
      }
      let currentItem = [], replaceItem = [], newItem = [];
      currentItem.push(this.fileActions[0]);
      replaceItem.push(this.fileActions[1]);
      newItem.push(this.fileActions[2]);
      this.checkActionItems.push([{id: 0, action: 'current', item: this.fileActions[0], checked: false, visible: true}, {id: 2, action: 'replace', item: this.fileActions[1], checked: false, visible: true}, {id: 3, action: 'new', item: this.fileActions[2], checked: false, visible: true}]);
    });
    console.log(this.checkActionItems)

    this.mediaItems.forEach((file, index) => {
      file['date'] = this.currentDateTime;
      let fname = file.name;
      let lastDot = fname.lastIndexOf('.');
      let fileName = fname.substring(0, lastDot);
      file['fileName'] = `${fileName}${this.currentDate}`;
      file['mediaId'] = this.existingItems[index].mediaId;
      let fileExtn = fname.split('.').pop();
      file['newFileName'] = `${file['fileName']}.${fileExtn}`;
      file['fileCaption'] = file['fileName'];
      file['fileExtension'] = fileExtn;
      this.initFileUpload(file);
    });
    setTimeout(() => {
      this.getMediaInfo();
    }, 500);
  }

  initFileUpload(file) {
    let flag = true;
    let fileType = file.type.split('/');
    let fileExtn = file.name.split('.').pop();
    switch (fileType[0]) {
      case 'image':
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event: any) => {
          let localUrl = event.target.result;
          file.thumbFilePath = localUrl;
        };
        break;
        case 'video':
          setTimeout(() => {
            let blobURL = URL.createObjectURL(file);
            file.videoFilePath = blobURL;
            file.thumbFilePath = `${this.mediaPath}/video-medium.png`;
          }, 500);
        break;
      case 'audio':
        setTimeout(() => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event: any) => {
            let localUrl = event.target.result;
            file.audioFilePath = localUrl;
          };
          file.thumbFilePath = `${this.mediaPath}/audio-medium.png`;
        }, 500);
        break;
      default:
        setTimeout(() => {
          let docThumb;
            let ext = fileExtn.toLowerCase();
            switch (ext) {
              case 'pdf':
                docThumb = 'pdf-medium';
                break;
              case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
              case 'xlsx':
              case 'xls':
                docThumb = 'xls-medium';
                break;
              case 'docx':
              case 'doc':
              case 'msword':
                docThumb = 'doc-medium';
                break;
              case 'vnd.openxmlformats-officedocument.presentationml.presentation':
              case 'pptx':
              case 'ppt':
                docThumb = 'ppt-medium';
                break;
              case 'txt':
                docThumb = 'txt-medium';
                break;
              case 'x-zip-compressed':
              case 'zip':
                docThumb = 'zip-medium';
                break;
              case 'exe':
                docThumb = 'exe-medium';
                break;
              case 'csv':
                docThumb = 'csv-medium';
                break;
              case 'html':
                docThumb = 'html-thumb-medium';
                break;
              case 'dat':
                docThumb = 'dat-medium';
                break;  
              default:
                docThumb = 'unknown-thumb';
                break;
            }
            file.fileExtension = fileExtn;
            if(ext == 'heic'){
              this.convertHEIC(file);
              this.heicImageInterval = setInterval(() => {
                console.log(this.heicImageConverted);
                if(this.heicImageConverted){
                  this.heicImageConverted = false;
                  console.log(this.imageUrl);
                  file.thumbFilePath = this.imageUrl;
                  file['heicImage'] = '1';
                  setTimeout(() => {
                     clearInterval(this.heicImageInterval);                     
                  }, 100);                 
                }                 
              }, 2000);              
            }
            else{
               file.thumbFilePath = `${this.mediaPath}/${docThumb}.png`;
               file.fileExtension = fileExtn;
            }
        }, 500);
    }
  }

  // Get Media Info
  getMediaInfo() {
    this.loading = true;
    this.changeFlag = false;
    this.currentMediaItem = [];
    this.currentMediaItem.push(this.existingItems[this.dynamicGid]);
    let workstreams: any = this.currentMediaItem[0].workstreams;
    let ws = (workstreams && workstreams != '') ? JSON.parse(this.currentMediaItem[0].workstreams) : [];
      let mws = [];
      ws.forEach(witem => {
        mws.push(parseInt(witem));
      });
      let intersections = this.userWorkstreams.filter(e => mws.indexOf(e) !== -1);
      let wsFlag = (intersections.length > 0) ? true : false;
      wsFlag = true;
      this.existingItems[this.dynamicGid].wsFlag = wsFlag;
      if(!wsFlag) {
        this.checkActionItems[this.dynamicGid].forEach((citem, cindex) => {
          if(cindex < 2) {
            citem.visible = false;
          }
        });
      }
      this.changeFlag = false;
      setTimeout(() => {
        this.initialLoad = false;
        this.loading = false;
        this.changeFlag = true;
        if (this.pageAccess == 'adasCalproReport') {
          let index = this.checkActionItems[this.dynamicGid].findIndex(x => x.action == 'new');
          if (index > -1) {
            this.onChangeAction(index, true);
          }
        }
      }, 50);
  }

  onPageChange(event: PageEvent) {
    this.initPage = event.page;
    this.rows = event.rows;
    this.dynamicGid = this.initPage;
    console.log(event, this.initPage, this.rows)
    this.getMediaInfo();
  }

  onChangeAction(i, startUpload = false) {
    console.log(this.checkActionItems[this.dynamicGid], i)
    if(!this.checkActionItems[this.dynamicGid][i].checked) {
      this.checkActionItems[this.dynamicGid][i].checked = true;
      let mid = this.mediaItems[this.dynamicGid]['mediaId'];
      let maction = this.checkActionItems[this.dynamicGid][i].action;
      this.existingItems[this.dynamicGid].mediaAction = maction; 
      this.mediaItems[this.dynamicGid]['mediaId'] = (maction == 'replace') ? mid : 0;      
    }
    this.checkActionItems[this.dynamicGid].forEach((actItem, ai) => {
      console.log(ai, i)
      if(ai != i) {
        console.log('out')
        actItem.checked = false;
      }
    });
    let checkIndex = this.actionItems.findIndex(option => option == this.initPage);
    if(checkIndex < 0) {
      this.actionItems.push(this.initPage);
    }
    this.submitFlag = (this.actionItems.length == this.existingItems.length) ? true : this.submitFlag;

    setTimeout(() => {
      if (startUpload && this.submitFlag) this.submitFiles();
    }, 100)
  }

  submitFiles() {
    let emitData = {
      action: 'submit',
      existingItems: this.existingItems,
      mediaItems: this.mediaItems
    };
    this.uploadAction.emit(emitData);
  }

  close() {
    const modalRef = this.modalService.open(ConfirmationComponent, { backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.access = 'Cancel Upload';
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if(receivedService) {
        let emitData = {
          action: 'close'
        };
        this.uploadAction.emit(emitData);
      }
    });    
  }


     public async onFileSelected(file: any): Promise<void> {
    console.log(file);
    if (file) {
      

      // Check if the file is HEIC/HEIF
      if (file.type === '' && (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif'))) {
        try {
          // Convert the HEIC blob to a web-compatible blob (e.g., JPEG)
          const convertedBlob: Blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          }) as Blob; // Cast to Blob for single image conversion

          // Create a URL for the converted image and display it
          this.imageUrl = URL.createObjectURL(convertedBlob);
          this.heicImageConverted = true;
        } catch (error) {
          console.error("Error converting HEIC image:", error);
          //alert("Could not convert the HEIC image.");
        }
      } else {
        // Handle non-HEIC images normally
        const reader = new FileReader();
        reader.onload = e => this.imageUrl = reader.result;
        reader.readAsDataURL(file);
      }
    }
  }
   
   convertHEIC(file){
      this.onFileSelected(file);
   }

}